import React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "svgs";

export default function GooglePlay(props) {
  return (
    <Svg width={168} height={48} viewBox="0 0 168 48" {...props}>
      <Defs>
        <LinearGradient x1="61.299%" y1="4.97%" x2="16.984%" y2="87.845%" id="a">
          <Stop stopColor="#00A0FF" offset="0%" />
          <Stop stopColor="#00A1FF" offset=".66%" />
          <Stop stopColor="#00BEFF" offset="26.01%" />
          <Stop stopColor="#00D2FF" offset="51.22%" />
          <Stop stopColor="#00DFFF" offset="76.04%" />
          <Stop stopColor="#00E3FF" offset="100%" />
        </LinearGradient>
        <LinearGradient
          x1="107.378%"
          y1="49.984%"
          x2="-190.634%"
          y2="49.984%"
          id="b"
        >
          <Stop stopColor="#FFE000" offset="0%" />
          <Stop stopColor="#FFBD00" offset="40.87%" />
          <Stop stopColor="orange" offset="77.54%" />
          <Stop stopColor="#FF9C00" offset="100%" />
        </LinearGradient>
        <LinearGradient
          x1="36.152%"
          y1="51.709%"
          x2="-134.834%"
          y2="178.965%"
          id="c"
        >
          <Stop stopColor="#FF3A44" offset="0%" />
          <Stop stopColor="#C31162" offset="100%" />
        </LinearGradient>
        <LinearGradient
          x1="-68.739%"
          y1="-30.674%"
          x2="7.521%"
          y2="26.013%"
          id="d"
        >
          <Stop stopColor="#32A071" offset="0%" />
          <Stop stopColor="#2DA771" offset="6.85%" />
          <Stop stopColor="#15CF74" offset="47.62%" />
          <Stop stopColor="#06E775" offset="80.09%" />
          <Stop stopColor="#00F076" offset="100%" />
        </LinearGradient>
      </Defs>
      <G fillRule="nonzero" fill="none">
        <Path
          d="M161.783 48H6.217C2.79 48 0 45.307 0 42.003V5.997C0 2.693 2.791 0 6.217 0h155.566C165.21 0 168 2.693 168 5.997v36.006c0 3.304-2.816 5.997-6.217 5.997z"
          fill="#000"
        />
        <Path
          d="M55.426 7.025c.527 0 1.028.099 1.504.297.476.198.877.47 1.153.817l-.652.644c-.501-.57-1.153-.867-2.03-.867a2.76 2.76 0 0 0-2.005.818c-.576.545-.852 1.238-.852 2.105s.276 1.56.852 2.105c.577.545 1.253.818 2.005.818.827 0 1.504-.273 2.055-.818.35-.346.576-.842.627-1.486H55.4v-.867h3.559c.075.149.075.322.075.52 0 1.016-.3 1.833-.902 2.428-.702.718-1.604 1.09-2.707 1.09-1.052 0-1.98-.372-2.706-1.09-.752-.743-1.128-1.635-1.128-2.725s.376-1.981 1.128-2.7c.752-.718 1.654-1.09 2.706-1.09zm15.337.148v.892h-2.055v6.39h-.952v-6.39H65.7v-.892h5.062zm-6.065-.024v.916H61.34v2.303h3.033v.867H61.34v2.304h3.358v.891h-4.31V7.15h4.31zM75.374 7.173v7.282h-.952V7.173h.952zm6.265 0v.892h-2.055v6.39h-.952v-6.39h-2.055v-.892h5.062zM88.53 7c1.078 0 1.98.372 2.707 1.115.726.743 1.102 1.634 1.102 2.7-.025 1.064-.376 1.956-1.102 2.699-.727.743-1.63 1.115-2.707 1.115s-1.98-.372-2.706-1.115c-.727-.743-1.078-1.635-1.078-2.7 0-1.065.351-1.981 1.078-2.7C86.55 7.373 87.453 7 88.53 7zm6.265.173l3.584 5.672h.05l-.05-1.411v-4.26h.952v7.281h-.977l-3.76-5.944h-.05l.05 1.412v4.532h-.952V7.173h1.153zm-6.265.694c-.802 0-1.453.272-2.005.817-.55.545-.826 1.239-.826 2.106 0 .866.275 1.56.826 2.105.552.545 1.203.817 2.005.817a2.76 2.76 0 0 0 2.005-.817c.551-.545.827-1.239.827-2.105 0-.867-.276-1.56-.827-2.106-.551-.545-1.203-.817-2.005-.817z"
          stroke="#FFF"
          strokeWidth={0.5}
          fill="#FFF"
        />
        <Path
          d="M84.496 25.08c-2.882 0-5.238 2.18-5.238 5.177 0 2.973 2.356 5.177 5.238 5.177 2.882 0 5.262-2.204 5.262-5.177 0-2.997-2.355-5.176-5.262-5.176zm0 8.298c-1.58 0-2.957-1.288-2.957-3.12 0-1.858 1.353-3.121 2.957-3.121 1.603 0 2.957 1.263 2.957 3.12 0 1.833-1.379 3.121-2.957 3.121zm-11.428-8.297c-2.882 0-5.237 2.18-5.237 5.176 0 2.973 2.355 5.177 5.237 5.177s5.238-2.204 5.238-5.177c0-2.997-2.356-5.176-5.238-5.176zm0 8.297c-1.578 0-2.957-1.288-2.957-3.12 0-1.858 1.379-3.121 2.957-3.121 1.58 0 2.957 1.263 2.957 3.12-.025 1.833-1.378 3.121-2.957 3.121zm-13.632-6.712v2.204h5.313c-.15 1.239-.577 2.13-1.203 2.75-.777.767-1.98 1.61-4.11 1.61a5.784 5.784 0 0 1-5.814-5.821c0-3.22 2.556-5.82 5.814-5.82 1.754 0 3.057.693 4.01 1.56l1.553-1.536c-1.328-1.263-3.082-2.204-5.563-2.204-4.486 0-8.245 3.591-8.245 8.025 0 4.433 3.76 8.025 8.245 8.025 2.43 0 4.235-.793 5.663-2.254 1.454-1.437 1.93-3.493 1.93-5.127 0-.52-.05-.991-.125-1.362 0-.05-7.468-.05-7.468-.05zm55.683 1.709c-.426-1.164-1.754-3.294-4.486-3.294-2.681 0-4.937 2.105-4.937 5.176 0 2.898 2.205 5.177 5.188 5.177 2.405 0 3.784-1.437 4.36-2.279l-1.78-1.164c-.6.867-1.403 1.437-2.58 1.437-1.153 0-2.005-.52-2.531-1.56l6.991-2.849c.025-.074-.225-.644-.225-.644zm-7.117 1.709c-.05-1.981 1.553-3.022 2.731-3.022.902 0 1.68.446 1.955 1.09-.025.025-4.686 1.932-4.686 1.932zm-5.689 5.028h2.306V19.929h-2.306v15.183zm-3.759-8.892h-.075c-.526-.594-1.504-1.14-2.757-1.14-2.606 0-5.012 2.28-5.012 5.177 0 2.898 2.406 5.152 5.012 5.152 1.253 0 2.23-.545 2.757-1.164h.075v.743c0 1.982-1.077 3.047-2.781 3.047-1.404 0-2.28-.991-2.632-1.833l-2.005.817c.577 1.362 2.106 3.047 4.637 3.047 2.706 0 4.961-1.56 4.961-5.375v-9.288h-2.18v.817zm-2.631 7.158c-1.579 0-2.907-1.313-2.907-3.12 0-1.833 1.328-3.146 2.907-3.146 1.554 0 2.782 1.337 2.782 3.145s-1.228 3.121-2.782 3.121zm29.971-13.474h-5.488v15.183h2.28v-5.746h3.208c2.557 0 5.037-1.833 5.037-4.706 0-2.898-2.506-4.73-5.037-4.73zm.05 7.332h-3.257v-5.202h3.258c1.704 0 2.681 1.412 2.681 2.601 0 1.164-.977 2.6-2.681 2.6zm14.184-2.18c-1.654 0-3.383.718-4.084 2.328l2.03.842c.426-.842 1.252-1.114 2.105-1.114 1.177 0 2.405.718 2.405 1.957v.148c-.426-.248-1.303-.594-2.405-.594-2.18 0-4.436 1.189-4.436 3.418 0 2.03 1.804 3.343 3.809 3.343 1.554 0 2.406-.693 2.932-1.486h.075v1.164h2.205v-5.82c.026-2.675-2.004-4.186-4.636-4.186zm-.275 8.322c-.752 0-1.805-.371-1.805-1.288 0-1.164 1.304-1.634 2.431-1.634 1.003 0 1.479.222 2.105.52a2.782 2.782 0 0 1-2.731 2.402zm13.006-8l-2.631 6.588h-.076l-2.731-6.588h-2.481l4.085 9.19-2.33 5.126h2.405l6.315-14.316h-2.556zm-20.675 9.734h2.306V19.929h-2.306v15.183z"
          fill="#FFF"
        />
        <Path
          d="M.576 30.752C.226 30.38 0 29.786 0 29.042V2.17C0 1.426.2.831.576.459l.1-.073 15.237 15.059v.346L.677 30.851l-.1-.1z"
          fill="url(#a)"
          transform="matrix(1 0 0 -1 13 38.569)"
        />
        <Path
          d="M20.975 10.417l-5.062 5.028v.346L21 20.82l.125-.074 6.015-3.393c1.704-.966 1.704-2.551 0-3.517l-6.015-3.369c-.025.025-.15-.05-.15-.05z"
          fill="url(#b)"
          transform="matrix(1 0 0 -1 13 38.569)"
        />
        <Path
          d="M21.1 26.11l-5.187 5.126L.601 16.103c.577-.595 1.504-.669 2.557-.074L21.1 26.109"
          fill="url(#c)"
          transform="matrix(1 0 0 -1 13 54.187)"
        />
        <Path
          d="M21.1 5.127L3.132 15.207c-1.052.595-1.98.52-2.556-.074L15.888 0 21.1 5.127z"
          fill="url(#d)"
          transform="matrix(1 0 0 -1 13 22.95)"
        />
      </G>
    </Svg>
  )
}
